export const FUND_TX_TYPE = {
    FUND_ADD: "add_fund",
    FUND_TRANSFER: "fund_transfer",
    FUND_CONVERT: "fund_convert",
    FUND_WITHDRAWAL: "fund_withdrawal"
}